import React from 'react';
import {Box, makeStyles, Typography} from '@material-ui/core';
import {useIntl} from 'react-intl';
import SelectVehicle from '@generic/components/VehicleSetDialog/SelectVehicle';

const useStyles = makeStyles((theme) => ({
  header: {
    fontSize: '1.125rem',
    fontWeight: 400,
    marginBottom: theme.spacing(1),
  },
  subheader: {
    fontSize: '1rem',
  },
}));

export default function VehicleTypes({inputs, handleInputChange}) {
  const {formatMessage} = useIntl();
  const classes = useStyles();

  const {vehicleSets} = inputs;
  // remove computed vehicle so it isn't included when we set the vehicle sets input
  const {vehicle, ...restOfVehicleSet} = vehicleSets[0];

  return (
    <Box>
      <Box mb={4}>
        <Typography variant="h2" className={classes.header}>
          {formatMessage({id: 'wizard.charging.vehicleTypes.header'})}
        </Typography>
        <Typography className={classes.subheader}>
          {formatMessage({id: 'wizard.charging.vehicleTypes.subheader'})}
        </Typography>
      </Box>
      <SelectVehicle
        vehicleSet={restOfVehicleSet}
        onChangeVehicleSet={(newData) =>
          handleInputChange('vehicleSets', [{...restOfVehicleSet, ...newData}])
        }
        variant="gray"
      />
    </Box>
  );
}
